export interface Testimonial {
  text: string;
  name: string;
  role: string;
}

export const testimonials: Testimonial[] = [
  {
    text: 'Compré EDUCACIÓN FÍSICA FLASH un domingo por la noche. El martes entré al patio con la sesión exacta planificada. Los alumnos lo notaron desde el primer ejercicio. Excelente.',
    name: 'María L.',
    role: 'Profesora de EF · IES Madrid'
  },
  {
    text: 'Pensé que era otro PDF teórico más. Pero esto es diferente. Las variantes inclusivas de cada sesión son oro puro. Ahora tengo respuesta para cada tipo de alumno.',
    name: 'Javier R.',
    role: 'Profesor EF · Primaria · Barcelona'
  },
  {
    text: 'Trabajo de lunes a viernes en el colegio y preparo mientras corrijo cuadernos. El tiempo es lo que más me falta. Este sistema me ha devuelto horas. Ya no planifico desde cero. Solo ejecuto.',
    name: 'Laura G.',
    role: 'Coordinadora de EF · Valencia'
  },
  {
    text: 'Al principio me pareció demasiado barato para ser bueno. Me equivoqué. La calidad está muy por encima del precio. Lo recomendaría a cualquier profesor de EF sin dudarlo.',
    name: 'Iñaki A.',
    role: 'Director Técnico · Bilbao'
  },
  {
    text: 'Llevo el PDF en el móvil y lo consulto en el patio sin que nadie lo note. Es como tener un segundo profesor al lado que te recuerda qué tienes que decir en cada momento.',
    name: 'Pablo C.',
    role: 'Profesor EF · Murcia'
  },
  {
    text: 'Llevaba dos trimestres sin saber si lo estaba haciendo bien. Con EDUCACIÓN FÍSICA FLASH por primera vez siento que hay un hilo conductor real en mis clases.',
    name: 'Sergio B.',
    role: 'Profesor EF · Valencia'
  },
  {
    text: 'El Bono #2 sobre LOMLOE me salvó. Cuando coordinación preguntó qué competencias trabajaba, tuve respuesta clara con datos. Eso es profesionalismo real.',
    name: 'Marta R.',
    role: 'Profesora EF · Sevilla'
  }
];
